export class FunctionViewModel {
    static $inject = ['init'];
    constructor(init) {
        if (!init) {
            this.key = '';
            this.name = '';
            this.settings = {};
            this.description = '';
            this.sourceScreen = '';
            this.functionName = '';
            this.applications = [];
            this.inputVariables = [];
            this.functionContent = '/**\n' +
                '* All input variables needs to be passed as function param;\n' +
                '* Objects received as param needs to be parsed. Ex.: JSON.parse(inputVariable1);\n' +
                '* Objects returned needs to be stringfied. Ex.: JSON.stringify(inputVariable1);\n' +
                '**/\n' +
                'function run(inputVariable1, inputVariable2) {\n\t' +
                'return "Hello BLiP"; //Return value will be saved as "Return value variable" field name\n' +
                '}';
            this.isEditingFunction = false;
        }
        else {
            Object.assign(this, init);
        }
    }
}
